import React from 'react';
import IconButton from '../Buttons/IconButton/IconButton';
import MoreOptions from './MoreOptions';
import ClickOutside from '../ClickOutside';
import SharePane from './SharePane';
import { TString } from '../Response/Utils/index';
import { loadStateSession } from '../../FlyfishComponents/flyfishutils/utils';
interface Props {
	onSelect: Function;
	data?: any;
	isUserLoggedin?: boolean;
	sessionComplete?: boolean;
	headerExternalTheme?: boolean;
	isOverlayVisible?: boolean;
	foreground: string;
	redirectToExternalBot?: Function;
	isInsideCampaign?: boolean;
	toggleLang?: Function;
	toggleOverlay?: Function;
	toShowRedDot?: boolean;
	restartFlow?: Function;
	hideBot?: Function;
	isChatBodyVisible?: boolean;
	handleModalToggle?: Function;
	feedbackDone?: boolean;
	isModalVisible?: boolean;
	triggerLogout?: Function;
	disableRefresh: boolean;
	isChatStarted: boolean;
}
export default function HeaderButtons(props: Props) {
	const [moreOptions, setMoreOptions] = React.useState(false);
	const [sharePane, setSharePane] = React.useState(false);

	const toggleMoreOptions = () => {
		setMoreOptions(!moreOptions);
	};
	const toggleSharePane = () => {
		setSharePane(!sharePane);
	};
	const getBackTitle = (data: any) => {
		props.onSelect(data);
	};
	const showMoreOptions = () => {
		let isOptions = false;
		if (
			(props.isOverlayVisible || props.headerExternalTheme) &&
			!props.isModalVisible &&
			((!props.isOverlayVisible && props.data.notification === 'true') ||
				props.data.isMultiLingualEnabled === 'true' ||
				props.isUserLoggedin)
		) {
			isOptions = true;
		}
		return isOptions;
	};
	let backTitle = TString({ labelName: 'backToChat' });
	// console.log(!props.headerExternalTheme && !props.isOverlayVisible)
	return (
		<>
			{props.data.isInsideCampaign &&
			props.data.notification !== 'true' &&
			props.data.isMultiLingualEnabled !== 'true' &&
			!props.isUserLoggedin ? null : (
				<div
					style={{ cursor: props.sessionComplete ? 'not-allowed' : '' }}
					className={`header-btn-wrapper ${
						props.headerExternalTheme ? 'top' : 'inline'
					}`}
				>
					{!props.headerExternalTheme && !props.isOverlayVisible ? (
						<>
							{props.data.isInsideKampsta ? (
								<div
									onClick={toggleSharePane}
									className='share-box'
									style={{ marginRight: sharePane ? '' : '8px' }}
								>
									<IconButton
										fill={props.foreground}
										variant={'empty'}
										size={'normal'}
										image={'share'}
										title={TString({ labelName: 'shareLabel' })}
										pressed={sharePane}
										channel={loadStateSession('channel')}
									/>
									{sharePane ? (
										<ClickOutside
											identifier='.share-pane-w'
											callback={() => {
												setSharePane(false);
											}}
										>
											<div className='share-pane-arrow' />
											<SharePane
												isBotDeployed={props.data.isBotDeployed}
												encryptedBotId={props.data.eB}
												redirectToExternalBot={props.redirectToExternalBot}
												isBotPublic={props.data.isBotPublic}
												isInsideCampaign={props.isInsideCampaign}
											/>
										</ClickOutside>
									) : null}
								</div>
							) : null}

							{/* {props.data.isMultiLingualEnabled === 'true' ? (
								<IconButton
									fill={props.foreground}
									variant={'empty'}
									size={'normal'}
									onClick={props.toggleLang}
									image={'language'}
									title={TString({ labelName: 'languageChange' })}
								/>
							) : null} */}

							{/* {props.data.notification === 'true' ? (
								<IconButton
									fill={props.foreground}
									variant={'empty'}
									size={'normal'}
									onClick={() => {
										props.toggleOverlay();
									}}
									image={
										props.toShowRedDot ? 'notification-full' : 'notification'
									}
									title={TString({
										labelName: props.toShowRedDot
											? 'notificationsLabel'
											: 'noNotificationLabel',
									})}
								/>
							) : null} */}
							{/* {
								(props.data.isInsideCampaign) ? (
									props.data.isInsideKampsta ? (
										<IconButton
											fill={props.headerExternalTheme ? null : props.foreground}
											variant={props.headerExternalTheme ? 'filled' : 'empty'}
											size={'normal'}
											onClick={() => {
												props.restartFlow();
											}}
											disabled={props.disableRefresh}
											image={'refresh'}
											title={
												props.disableRefresh
													? TString({
														labelName:
															'pleaseWaitForProcessingTocompleteToRefreshTheChatLabel',
													})
													: TString({ labelName: 'refreshLabel' })
											}
											channel={loadStateSession('channel')}
										/>
									) : null
								) : null} */}
						</>
					) : null}
					{props.data.isInsideCampaign ||
					(props.headerExternalTheme && props.isModalVisible) ||
					(!props.headerExternalTheme && props.isOverlayVisible) ? null : (
						<>
							{/* {(props.data.flyFishChangesReq) &&
								props.headerExternalTheme ? (
								props.data.isInsideKampsta ? (
									<div
										onClick={toggleSharePane}
										className='share-box'
										style={{ marginRight: sharePane ? '' : '8px' }}
									>
										<IconButton
											fill={props.headerExternalTheme ? null : props.foreground}
											variant={props.headerExternalTheme ? 'filled' : 'empty'}
											size={'normal'}
											image={'share'}
											title={TString({ labelName: 'shareLabel' })}
											pressed={sharePane}
										/>
										{sharePane ? (
											<ClickOutside
												identifier='.share-pane-w'
												callback={() => {
													setSharePane(false);
												}}
											>
												<div className='share-pane-arrow' />
												<SharePane
													isBotDeployed={props.data.isBotDeployed}
													encryptedBotId={props.data.eB}
													redirectToExternalBot={props.redirectToExternalBot}
													isBotPublic={props.data.isBotPublic}
													isInsideCampaign={props.isInsideCampaign}
												/>
											</ClickOutside>
										) : null}
									</div>
								) : null
							) : null} */}

							{props.headerExternalTheme ? (
								props.data.isInsideKampsta ? (
									<IconButton
										fill={props.headerExternalTheme ? null : props.foreground}
										variant={props.headerExternalTheme ? 'filled' : 'empty'}
										size={'normal'}
										onClick={() => {
											props.restartFlow();
										}}
										disabled={props.disableRefresh}
										image={'refresh'}
										title={
											props.disableRefresh
												? TString({
														labelName:
															'pleaseWaitForProcessingTocompleteToRefreshTheChatLabel',
												  })
												: TString({ labelName: 'refreshLabel' })
										}
									/>
								) : null
							) : null}
							{/* {!props.data.isInsideKampsta ? (
								<IconButton
									fill={props.headerExternalTheme ? null : props.foreground}
									variant={props.headerExternalTheme ? 'filled' : 'empty'}
									size={'normal'}
									onClick={() => {
										// props.toggleChatBody();
										props.hideBot();
									}}
									image={props.isChatBodyVisible ? 'minimise' : 'maximise'}
									title={TString({
										labelName: props.isChatBodyVisible
											? 'minimiseLabel'
											: 'maximiseLabel',
									})} //
								/>
							) : null} */}
							{/* {

								!props.data.isInsideKampsta ? (
									<IconButton
										fill={props.headerExternalTheme ? null : props.foreground}
										variant={props.headerExternalTheme ? 'filled' : 'empty'}
										size={'normal'}
										onClick={() => {
											// if (props.handleModalToggle) {
											if (props.isChatStarted) {
												if (props.feedbackDone)
													props.handleModalToggle(true, false, true);
												// else props.handleModalToggle(false, true, true); //this is to open feedback on close
												else props.handleModalToggle(false, false, false); //this is to removed when open feedback on close
											} else {
												props.handleModalToggle(true, false, true);
											}
										}}
										image={'close'}
										title={TString({ labelName: 'closeLabel' })}
									/>
								) : null
							} */}
						</>
					)}

					{showMoreOptions() ? (
						<IconButton
							className='no-margin'
							fill={props.headerExternalTheme ? null : props.foreground}
							variant={props.headerExternalTheme ? 'filled' : 'empty'}
							size={'normal'}
							onClick={() => {
								toggleMoreOptions();
								getBackTitle(backTitle);
							}}
							image={'ellipses'}
							title={TString({ labelName: 'moreOptionsLabel' })}
						/>
					) : null}
					{moreOptions ? (
						<ClickOutside
							identifier='.more-options'
							callback={() => toggleMoreOptions()}
						>
							<MoreOptions {...props} closepane={() => toggleMoreOptions()} />
						</ClickOutside>
					) : null}
				</div>
			)}
		</>
	);
}
